module.exports = __webpack_public_path__ + "img/av174.44046591.png";